// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3Grjh","label":"Section_label__3XAC7","contentWrap":"Section_contentWrap__2NkJY","footer":"Section_footer__2cbo3","footerInner":"Section_footerInner__gHQnn"};